import * as React from 'react'

export interface LocationResolver {
  pathQueryFragment: () => string
  href: () => string
  origin: () => string
  search: () => string
  redirectTo: (url: string) => void
  replaceWith: (url: string) => void
}

export function createLocation(location: Location | null | undefined = globalThis.location): LocationResolver {
  function pathQueryFragment() {
    return location ? location.pathname + location.search + location.hash : ''
  }

  function href() {
    return location?.href ?? ''
  }

  function origin() {
    return location?.origin ?? ''
  }

  function search() {
    return location?.search ?? ''
  }

  function redirectTo(url: string) {
    if (location)
      location.href = url
  }

  function replaceWith(url: string) {
    if (location)
      location.replace(url)
  }

  return {
    pathQueryFragment,
    href,
    origin,
    search,
    redirectTo,
    replaceWith,
  }
}

export function useLocation(): LocationResolver {
  return React.useMemo(() => createLocation(), [])
}
